<script setup lang="ts">
import { VueQueryDevtools } from "@tanstack/vue-query-devtools";
import { computed } from "vue";

import SuspenseRouterView from "@/components/SuspenseRouterView.vue";
import Toast from "@/components/Toast.vue";
import { useToast } from "@/composables/useToast";

const { toasts } = useToast();

const computedToasts = computed(() => {
  return toasts.value;
});
</script>

<template>
  <SuspenseRouterView />

  <div
    aria-live="assertive"
    class="pointer-events-none fixed inset-0 z-20 flex items-end px-4 py-6 sm:items-start sm:p-6"
  >
    <div id="toasts" class="flex w-full flex-col items-center space-y-4 sm:items-end">
      <Toast v-for="(toast, index) in computedToasts" :key="index" v-bind="toast" />
    </div>
  </div>
  <VueQueryDevtools />
</template>
